var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInboxPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "inbox-post--mail-flag-new-open-inbox-mailbox-post"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1098",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    d: "m11 13 26 0c4.613 0 7.872 3.652 7.958 8.265 0.026 1.375 0.042 2.95 0.042 4.735 0 4.48 -0.102 7.637 -0.2 9.642 -0.081 1.653 -1.247 2.99 -2.895 3.148 -1.199 0.115 -2.819 0.21 -4.905 0.21l-26 0",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.107 39c0.075 1.602 0.175 3.105 0.252 4.151 0.063 0.87 0.692 1.592 1.557 1.704 0.605 0.078 1.339 0.145 2.084 0.145a16.5 16.5 0 0 0 2.084 -0.145c0.865 -0.112 1.494 -0.834 1.558 -1.704 0.076 -1.047 0.176 -2.55 0.251 -4.151",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1097",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    d: "M11 13c-4.613 0 -7.872 3.652 -7.958 8.265A254.36 254.36 0 0 0 3 26c0 4.48 0.102 7.637 0.2 9.642 0.081 1.653 1.247 2.99 2.895 3.148 1.199 0.115 2.819 0.21 4.905 0.21 2.086 0 3.706 -0.095 4.905 -0.21 1.648 -0.159 2.814 -1.495 2.895 -3.148 0.098 -2.005 0.2 -5.162 0.2 -9.642 0 -1.785 -0.016 -3.36 -0.042 -4.735C18.872 16.652 15.613 13 11 13Z",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1099",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m26 3 3.5 0c0.345 0 0.66 0.003 0.947 0.007C31.882 3.029 33 4.065 33 5.5c0 1.435 -1.118 2.47 -2.553 2.493 -0.287 0.004 -0.602 0.007 -0.947 0.007L26 8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1483",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14 22H8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1484",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M26 30V3",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxPost);
export default __webpack_public_path__ + "static/media/inbox-post.e6d8ab7ccad287000b679f834024d17e.svg";
export { ForwardRef as ReactComponent };